import TGASDK from '@/config/TGASDK'
import React, { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

const RedirectLayout: React.FC<PropType> = () => {
  const { appCode } = TGASDK.context.appConfig
  const navigate = useNavigate()

  useEffect(() => {
    navigate(`/${appCode.toLowerCase()}/`, { replace: true })
  })

  return null
}

interface PropType {}

export default RedirectLayout
